import MainDashbord from '../features/dashboard/components/MainDashbord';

const dashboard= () => {
   
  return <MainDashbord />;

  }
export default dashboard
